import MaterialTable, { TableProps } from '@mui/material/Table';

export function Table(props: TableProps) {
    return <MaterialTable data-testid={'Table-container'} {...props} />;
}

export default Table;
